<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  styleClass="user-skill-dialog"
  [style]="{ width: '480px', maxWidth: '95vw' }">

  <ng-template #header>
    <div class="d-flex align-items-center gap-3">
      <i class="pi pi-star" style="font-size: 1.5rem; color: var(--acx-primary)"></i>
      <div>
        <div class="fw-semibold">
          {{ 'Skill::SkillManagement:Title' | abpLocalization }} &mdash; {{ user?.userName }}
        </div>
        <div class="text-muted small">{{ user?.email }}</div>
      </div>
    </div>
  </ng-template>

  <div *ngIf="loading" class="text-center py-4">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Info box -->
    <div class="alert alert-info border-0 d-flex align-items-center gap-2 py-2 px-3 mb-3 rounded-2" role="alert">
      <i class="pi pi-info-circle flex-shrink-0"></i>
      <span class="small">{{ 'Skill::SkillManagement:InfoMessage' | abpLocalization }}</span>
    </div>

    <!-- Skill selector row -->
    <div class="d-flex gap-2 mb-1">
      <cx-select
        class="flex-grow-1"
        appendTo="body"
        [filter]="false"
        [options]="availableSkills"
        optionLabel="name"
        optionValue="id"
        [placeholder]="'Skill::SkillManagement:SelectSkill' | abpLocalization"
        [(ngModel)]="selectedSkillId" />
      <button
        type="button"
        class="btn btn-primary btn-sm text-nowrap"
        [disabled]="!selectedSkillId"
        (click)="onAdd()">
        + {{ 'Skill::SkillManagement:Add' | abpLocalization }}
      </button>
    </div>

    <!-- Link to settings -->
    <div class="mb-3">
      <button
        type="button"
        class="btn btn-link text-muted small p-0 align-baseline"
        (click)="onNavigateToSettings()">
        <i class="pi pi-link me-1" style="font-size: 0.75rem;"></i>
        {{ 'Skill::SkillManagement:NotInList' | abpLocalization }}
      </button>
    </div>

    <!-- Skills list -->
    <ng-container *ngIf="assignments.length > 0; else noSkills">
      <!-- Star column labels -->
      <div class="d-flex justify-content-end align-items-center mb-1" style="padding-right: 1.75rem;">
        <div class="d-flex align-items-center justify-content-between" style="width: 6.25rem;">
          <span class="text-muted small" style="width: 1.15rem; text-align: center;" *ngFor="let n of [1,2,3,4,5]">{{ n }}</span>
        </div>
      </div>

      <div
        *ngFor="let a of assignments; trackBy: trackByAssignment; let i = index"
        class="d-flex align-items-center gap-2 py-2 border-bottom">
        <div class="flex-grow-1 min-w-0">
          <div class="fw-semibold small text-truncate">{{ a.skillName }}</div>
          <div class="text-muted" style="font-size: 0.72rem;">{{ getProficiencyLabel(a.proficiencyLevel) }}</div>
        </div>
        <p-rating [(ngModel)]="a.proficiencyLevel" [cancel]="true" styleClass="mx-1" />
        <button
          type="button"
          class="btn btn-link p-0 ms-1 text-muted flex-shrink-0"
          (click)="onRemove(i)">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </ng-container>

    <ng-template #noSkills>
      <div class="text-center py-4">
        <i class="pi pi-star" style="font-size: 2rem; color: var(--acx-border-subtle);"></i>
        <div class="text-muted mt-2 small">{{ 'Skill::SkillManagement:NoSkills' | abpLocalization }}</div>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #footer>
      <div class="d-flex flex-column align-items-end gap-2">
      <div *ngIf="hasInvalidLevelAssignment" class="small text-warning d-flex align-items-center gap-1">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'Skill::SkillManagement:LevelRequiredWarning' | abpLocalization }}</span>
      </div>

      <cx-form-actions
        layout="dialog"
        cancelVariant="outline-secondary"
        [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
        [saveLabel]="'AbpUi::Save' | abpLocalization"
        saveType="button"
        [disabled]="!canSave || saving"
        [isSubmitting]="saving"
        (cancel)="onCancel()"
        (save)="onSave()">
      </cx-form-actions>
      </div>
  </ng-template>
</p-dialog>
